export const LABORAL_FLUJO_OPEN_STORAGE_KEY = "vf:laboral-flujo-open";
export const LABORAL_FLUJO_OPEN_STATE_KEY = "laboralFlujoOpen";
export const LABORAL_FLUJO_HUB_RESET_EVENT = "vf:laboral-flujo-collapse-hub";

/** Vuelve al grid de tarjetas (hub) sin cambiar de ruta — p. ej. «Inicio del módulo» en /laboral/inicio. */
export function requestLaboralFlujoCollapseToHub() {
  try {
    sessionStorage.removeItem(LABORAL_FLUJO_OPEN_STORAGE_KEY);
  } catch {
    /* storage no disponible */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(LABORAL_FLUJO_HUB_RESET_EVENT));
  }
}

export function markLaboralFlujoOpenOnArrival(step) {
  try {
    if (step == null) return;
    sessionStorage.setItem(LABORAL_FLUJO_OPEN_STORAGE_KEY, String(step));
  } catch {
    /* storage no disponible */
  }
}

export function consumeLaboralFlujoOpenFlag(activeStep) {
  try {
    const stored = sessionStorage.getItem(LABORAL_FLUJO_OPEN_STORAGE_KEY);
    if (stored == null || activeStep == null) return false;
    if (Number(stored) !== Number(activeStep)) return false;
    sessionStorage.removeItem(LABORAL_FLUJO_OPEN_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}
